module.exports = __webpack_public_path__ + "img/img8.a45b2c6a.png";